import React from "react";
import { canOpenAppSettings, openApplicationSettings } from "../cordova_plugins";
import { PermissionDeniedState, PermissionType } from "../hooks/usePermissionDeniedModal";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppModalAction, ErrorModal } from "./Generic/AppModal/AppModal";

interface Props {
  state: PermissionDeniedState;
  onClose: () => void;
}

const PermissionDeniedModal: React.FC<Props> = ({ state, onClose }) => {
  const handleOpenSettings = React.useCallback(() => {
    if (canOpenAppSettings()) {
      openApplicationSettings();
      onClose.call(null);
    }
  }, [onClose]);

  const actions: AppModalAction[] = React.useMemo(
    () => [
      canOpenAppSettings()
        ? {
            key: "open_settings",
            variant: "soft",
            color: "primary",
            children: "🔧 Go to Settings",
            onClick: handleOpenSettings,
          }
        : {
            key: "close",
            variant: "soft",
            color: "danger",
            children: translate(STRINGS.CLOSE),
            onClick: onClose,
          },
      {
        key: "close",
        variant: "link",
        color: "black",
        children: translate(STRINGS.CLOSE),
        onClick: onClose,
      },
    ],
    [onClose, handleOpenSettings]
  );

  if (!state.isOpen) {
    return null;
  }

  const title = strings[state.permissionType].title;
  const message = strings[state.permissionType].message;

  return (
    <ErrorModal
      isOpen={state.isOpen}
      title={title}
      message={message}
      actions={actions}
      onRequestClose={onClose}
    />
  );
};

const strings: Record<PermissionType, { title: string; message: string }> = {
  camera: {
    title: translate(STRINGS.PERMISSION_NEEDED_FOR_CAMERA),
    message: translate(STRINGS.PERMISSION_NEEDED_FOR_CAMERA_MESSAGE),
  },
  photos: {
    title: translate(STRINGS.PERMISSION_NEEDED_FOR_PHOTOS),
    message: translate(STRINGS.PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE),
  },
};

export default PermissionDeniedModal;
